import { CSSProperties } from 'react'
import { Popup } from "antd-mobile"
import styles from './style.scss'
import { IPhoneData } from "../../types/common"
import phoneCallIcon from './assets/phone_call.png'

interface Iprops {
    onCancel(): void
    visible: boolean
    title?: string
    phoneList: IPhoneData[]
    themeStyle?: CSSProperties
}


const loop = () => { }

// 数据由外部传入
export default function ServicePhonePopup(props: Iprops) {
    const {
        onCancel = loop,
        visible = false,
        phoneList = [],
        themeStyle,
    } = props

    return (
        <Popup
            visible={visible}
            onMaskClick={onCancel}
            showCloseButton
            getContainer={() => document.body}
            bodyClassName={styles.customizeServicePopup}
            bodyStyle={{
                borderTopLeftRadius: '24px',
                borderTopRightRadius: '24px',
                ...themeStyle,
            }}
            onClose={onCancel}
        >
            <div className={styles.customizeService}>
                <h3 className={styles.customizePopupTitle}>客服电话</h3>
                <div className={styles.customizePopupList}>
                    {phoneList.filter((item) => item.enable).map((item, index) => (
                        <a
                            className={styles.customizePopupItem}
                            key={index}
                            href={`tel:${item.tel}`}
                        >
                            <span className={styles.customizePopupItemInfo}>
                                <span className={styles.customizePopupItemName}>{item.name}</span>
                                <strong className={styles.customizePopupItemTel}>{item.tel}</strong>
                            </span>
                            <span
                                className={styles.customizePopupItemIcon}
                                style={{
                                    maskImage: `url(${phoneCallIcon})`,
                                    WebkitMaskImage: `url(${phoneCallIcon})`,
                                } as CSSProperties}
                                aria-hidden="true"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </Popup>
    )
}
